import { ThirdPartyScriptData } from './response-data-validator';
import { ThirdPartyScriptDefinition } from './types';
import { ClarityScript } from './scripts/clarity';
import { GTMBodyScript } from './scripts/gtm-body';
import { GTMHeadScript } from './scripts/gtm-head';
import { WebengageScript } from './scripts/webengage';
export const thirdPartyScriptRegistry = {
  gtm: {
    placement: 'head',
    render: (thirdPartyData: ThirdPartyScriptData) => <GTMHeadScript gtmData={thirdPartyData.gtm} />
  },
  clarity: {
    placement: 'body',
    render: (thirdPartyData: ThirdPartyScriptData) => <ClarityScript clarityData={thirdPartyData.clarity} />
  },
  gtmBody: {
    placement: 'body',
    render: (thirdPartyData: ThirdPartyScriptData) => <GTMBodyScript gtmData={thirdPartyData.gtm} />
  },
  webengage: {
    placement: 'body',
    render: (thirdPartyData: ThirdPartyScriptData) => <WebengageScript webengageData={thirdPartyData.webengage} />
  }
} satisfies Record<string, ThirdPartyScriptDefinition>;